var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Performance),
      expression: "Performance"
    }]
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-35px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("履约金管理")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "780px",
      "background-color": "white",
      "margin": "75px 40px 0 40px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "3%"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": "10px",
      "margin-left": "10px"
    }
  }, [_vm._v("公司名头")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.partner_id),
      callback: function($$v) {
        _vm.$set(_vm.condition, "partner_id", $$v)
      },
      expression: "condition.partner_id"
    }
  }, _vm._l((_vm.partnerList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.partner_abbreviation,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("组织架构")]), _vm._v(" "), _c('el-cascader', {
    staticStyle: {
      "margin-left": "10px",
      "width": "300px"
    },
    attrs: {
      "clearable": "",
      "collapse-tags": "",
      "props": _vm.props
    },
    on: {
      "change": _vm.changeCascader
    },
    model: {
      value: (_vm.organize_ids),
      callback: function($$v) {
        _vm.organize_ids = $$v
      },
      expression: "organize_ids"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": "10px",
      "margin-left": "10px"
    }
  }, [_vm._v("项目名称")]), _vm._v(" "), _c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.condition.projectName),
      callback: function($$v) {
        _vm.$set(_vm.condition, "projectName", $$v)
      },
      expression: "condition.projectName"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": "10px",
      "margin-left": "10px"
    }
  }, [_vm._v("申请人")]), _vm._v(" "), _c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.condition.applicantName),
      callback: function($$v) {
        _vm.$set(_vm.condition, "applicantName", $$v)
      },
      expression: "condition.applicantName"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "rz"
  }, [_c('span', {
    staticStyle: {
      "margin-right": "10px",
      "margin-left": "10px"
    }
  }, [_vm._v("付款时间")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "format": "yyyy-MM-dd",
      "end-placeholder": "结束日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.condition.start_date),
      callback: function($$v) {
        _vm.$set(_vm.condition, "start_date", $$v)
      },
      expression: "condition.start_date"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": "10px",
      "margin-left": "10px"
    }
  }, [_vm._v("金额")]), _vm._v(" "), _c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.condition.money_amount),
      callback: function($$v) {
        _vm.$set(_vm.condition, "money_amount", $$v)
      },
      expression: "condition.money_amount"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "85px",
      "height": "41px"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.Find
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "85px",
      "height": "41px"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.Add
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "190px"
    }
  }, [_c('download-excel', {
    staticClass: "export-excel-wrapper",
    staticStyle: {
      "margin-left": "-180px",
      "top": "100px"
    },
    attrs: {
      "fields": _vm.download_excel,
      "title": "转正人员清单",
      "name": "转正人员清单.xls",
      "fetch": _vm.ExportForm
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    attrs: {
      "type": "goon"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t导出")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "3% 2% 0 2%"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#F0F0F0',
        color: '#000000'
      },
      "data": _vm.tableData,
      "tooltip-effect": "dark",
      "height": "530"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "partnerName",
      "label": "公司名头",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "组织架构",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$globals.group_name + "/" + scope.row.organizeName) + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "projectName",
      "label": "项目名称",
      "align": "center",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "areaManagerName",
      "label": "区域总管",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "money_amount",
      "label": "金额",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "applicantName",
      "label": "申请人",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "estimate_payment_time",
      "label": "预计付款时间",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payment_time",
      "label": "付款时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "付款凭证",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": require("../../../assets/查看.png")
          },
          on: {
            "click": function($event) {
              return _vm.Voucher(scope.row.id)
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "uncollected_payment_money",
      "label": "未回款金额",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spare",
      "label": "是否撤场",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "is_receipt",
      "label": "收据情况",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.is_receipt == '0') ? _c('span', [_vm._v("无")]) : _vm._e(), _vm._v(" "), (scope.row.is_receipt == '1') ? _c('span', [_vm._v("有")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "保证金收据",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": require("../../../assets/查看.png")
          },
          on: {
            "click": function($event) {
              return _vm.Voucher(scope.row.id)
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spare",
      "label": "备注",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "modified_time",
      "label": "最后操作时间",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态",
      "align": "center",
      "fixed": "right",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status === '0'),
            expression: "scope.row.status === '0' "
          }],
          attrs: {
            "src": require("../../../assets/stateImg/状态_未生效.png")
          }
        }), _vm._v(" "), _c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status === '1'),
            expression: "scope.row.status === '1' "
          }],
          attrs: {
            "src": require("../../../assets/stateImg/状态_已生效.png")
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "当前节点",
      "align": "center",
      "fixed": "right",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "color": "#006E4B",
            "text-decoration": "underline"
          },
          on: {
            "click": function($event) {
              return _vm.panelPoint(scope.row)
            }
          }
        }, [_c('span', [_vm._v("节点A")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "fixed": "right",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": require("../../../assets/icon/回款管理.png")
          },
          on: {
            "click": function($event) {
              return _vm.Manage(scope.row.id)
            }
          }
        }), _vm._v(" "), _c('img', {
          attrs: {
            "src": require("../../../assets/icon/付款登记及修改.png")
          },
          on: {
            "click": function($event) {
              return _vm.Update(scope.row)
            }
          }
        }), _vm._v(" "), _c('img', {
          attrs: {
            "src": require("../../../assets/icon/修改.png")
          },
          on: {
            "click": function($event) {
              return _vm.Revise(scope.row)
            }
          }
        }), _vm._v(" "), _c('img', {
          attrs: {
            "src": require("../../../assets/icon/删除.png")
          },
          on: {
            "click": function($event) {
              return _vm.Del(scope.row.id)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-left": "500px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.page_size,
      "layout": " prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.ruleForm.id == null || _vm.ruleForm.id == '' ? '新增' : '修改',
      "visible": _vm.showadd,
      "width": "30%",
      "center": "true",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showadd = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "label": "公司名头",
      "prop": "dictionaries_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.partner_id),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "partner_id", $$v)
      },
      expression: "ruleForm.partner_id"
    }
  }, _vm._l((_vm.partnerList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.partner_abbreviation,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id == null || _vm.ruleForm.id == ''),
      expression: "ruleForm.id == null || ruleForm.id == ''"
    }],
    attrs: {
      "label": "组织架构",
      "prop": "project_id"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "collapse-tags": "",
      "props": _vm.props
    },
    on: {
      "change": _vm.changeCascader
    },
    model: {
      value: (_vm.organize_id),
      callback: function($$v) {
        _vm.organize_id = $$v
      },
      expression: "organize_id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id != null && _vm.ruleForm.id != ''),
      expression: "ruleForm.id != null && ruleForm.id != ''"
    }],
    attrs: {
      "label": "组织架构",
      "prop": "project_id"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #DCDFE6",
      "width": "340px",
      "border-radius": "5px",
      "padding-left": "10px",
      "padding-right": "10px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.$globals.group_name + "/" + _vm.ruleForm.organizeName) + "\n\t\t\t\t\t\t\t")])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "label": "区域总管",
      "prop": "dictionaries_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.area_manager_id),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "area_manager_id", $$v)
      },
      expression: "ruleForm.area_manager_id"
    }
  }, _vm._l((_vm.overmanList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.staff_name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "label": "项目名称",
      "prop": "dictionaries_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.project_id),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "project_id", $$v)
      },
      expression: "ruleForm.project_id"
    }
  }, _vm._l((_vm.projectList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.project_name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "金额",
      "prop": "money_amount"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.ruleForm.money_amount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "money_amount", $$v)
      },
      expression: "ruleForm.money_amount"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "预计付款日期",
      "prop": "reason"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.ruleForm.estimate_payment_time),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "estimate_payment_time", $$v)
      },
      expression: "ruleForm.estimate_payment_time"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "money"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "placeholder": "请输入备注"
    },
    model: {
      value: (_vm.ruleForm.spare),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "spare", $$v)
      },
      expression: "ruleForm.spare"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin": "0 100px"
    }
  }, [(_vm.ruleForm.id == null || _vm.ruleForm.id == '') ? _c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.AddSave()
      }
    }
  }, [_vm._v("保存\n\t\t\t\t\t")]) : _c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.ReviseSave()
      }
    }
  }, [_vm._v("修改")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择姓名",
      "visible": _vm.dialogVisible,
      "width": "40%",
      "center": "true",
      "close-on-click-modal": false,
      "show-close": false,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-row', [_c('organizeStaff', {
    ref: "organizeStaff",
    attrs: {
      "type": "radio",
      "accordion": false,
      "staff_id_prop": _vm.ruleForm.staff_id
    },
    on: {
      "commit": _vm.saveChange
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.$refs['organizeStaff'].commit()
      }
    }
  }, [_vm._v("确定\n\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看审批流程",
      "visible": _vm.showPoint,
      "width": "35%",
      "center": "true",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showPoint = $event
      }
    }
  }, [_c('point', {
    ref: "points"
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.showVoucher,
      "width": "30%",
      "center": "true",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showVoucher = $event
      }
    }
  }, [_vm._l((_vm.VoucherList.photoList), function(item) {
    return _c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "300px"
      },
      attrs: {
        "src": item.honour_photo
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "margin-top": "10px",
        "margin-bottom": "20px"
      }
    }, [_c('img', {
      staticStyle: {
        "vertical-align": "middle"
      },
      attrs: {
        "src": require("../../../assets/小下载.png")
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#006E4B",
        "font-size": "16px"
      }
    }, [_vm._v("下载")])])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  })], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "付款登记及修改",
      "visible": _vm.showUpdate,
      "width": "30%",
      "center": "true",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showUpdate = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    attrs: {
      "label-position": "right",
      "label-width": "80px",
      "model": _vm.formLabelAlign
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "付款时间"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "value-format": "yyyy-MM-dd HH:mm",
      "placeholder": "选择日期时间"
    },
    model: {
      value: (_vm.updatePhoto.payment_time),
      callback: function($$v) {
        _vm.$set(_vm.updatePhoto, "payment_time", $$v)
      },
      expression: "updatePhoto.payment_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "付款凭证"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.$globals.http + '/file/upload',
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.handleRemove,
      "before-remove": _vm.beforeremove,
      "on-success": _vm.handleAvatarSuccess,
      "file-list": _vm.photoList
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisibles
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibles = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.photoList,
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin": "0  100px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.AddSavePhoto()
      }
    }
  }, [_vm._v("保存\n\t\t\t\t\t\t")])], 1)], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "审核",
      "visible": _vm.spShow,
      "width": "35%",
      "center": "true",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.spShow = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', [_vm._v("审核名称：履约金审核")]), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#F0F0F0',
        color: '#000000'
      },
      "data": _vm.tableDataList.examineDetailsList,
      "tooltip-effect": "dark",
      "height": "300"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "node",
      "label": "节点",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "role_name",
      "label": "岗位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff_name",
      "label": "审核总监",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.AddSavesp()
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看审批流程",
      "visible": _vm.showPoint,
      "width": "25%",
      "center": "true",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showPoint = $event
      }
    }
  }, _vm._l((_vm.approveList), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "approve"
    }, [_c('div', {
      staticClass: "approve-left"
    }, [(item.reviewer_state == 1) ? _c('img', {
      staticClass: "approve-img",
      attrs: {
        "src": require("../../../assets/oa/flowPath-green.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.reviewer_state == 2) ? _c('img', {
      staticClass: "approve-img",
      attrs: {
        "src": require("../../../assets/oa/flowPath-red.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.reviewer_state == 0) ? _c('img', {
      staticClass: "approve-img",
      attrs: {
        "src": require("../../../assets/oa/flowPath-orange.png"),
        "alt": ""
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "position"
    }, [_c('div', {
      staticClass: "position-left"
    }, [_c('div', [_vm._v(_vm._s(item.staff_name))]), _vm._v(" "), _c('div', {
      class: item.reviewer_state == 0 ? 'orange' : item.reviewer_state == 1 ? 'green' : item.reviewer_state == 2 ? 'red' : 'blue'
    }, [(item.reviewer_state == 1) ? _c('span', [_vm._v("已同意")]) : _vm._e(), _vm._v(" "), (item.reviewer_state == 2) ? _c('span', [_vm._v("已驳回")]) : _vm._e(), _vm._v(" "), (item.reviewer_state == 0) ? _c('span', [_vm._v("待审批")]) : _vm._e()]), _vm._v(" "), (item.reviewer_state == 2) ? _c('div', {
      staticClass: "position-refuse"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t驳回原因：" + _vm._s(item.reject_reason) + "\n\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), (item.reviewer_state != 0) ? _c('div', {
      staticClass: "position-time"
    }, [_vm._v(_vm._s(item.reviewer_date))]) : _vm._e()])]), _vm._v(" "), (index != _vm.approveList.length - 1) ? _c('div', {
      staticClass: "approve-hr"
    }) : _vm._e()])
  }), 0)], 1), _vm._v(" "), (_vm.showManage) ? _c('manage', {
    ref: "manages",
    attrs: {
      "conditions": _vm.conditions,
      "manageList": _vm.manageList
    },
    on: {
      "close": _vm.closeManage
    }
  }) : _vm._e()], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eb2c33a","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tender/Performance/Performance.vue
// module id = null
// module chunks = 